import { useRef, useState } from "react";
import CustomerVoucherDelete from "./customer-voucher-delete";
import CustomerVoucherEdit from "./customer-voucher-edit";
import CustomerVoucherList from "./customer-voucher-list";

const CustomerVoucherMain = (props) => {
  const listRef = useRef(null);

  const [visibleEditorDialog, setVisibleEditorDialog] = useState(false);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  const handleOnClickRowEdit = (row) => {
    setEditorData(row);
    setVisibleEditorDialog(true);
  };

  const handleOnClickRowDelete = (row) => {
    if (row.id && row.id > 0) {
      setEditorData(row);
      setVisibleDeleteDialog(true);
    }
  };

  const handleOnClickAddNew = () => {
    setEditorData({});
    setVisibleEditorDialog(true);
  };

  const handleOnConfirmedEdit = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDialog(false);
  };

  const handleOnConfirmedDelete = (data) => {
    listRef.current.handleOnDeleteViewRow(data);
    setVisibleDeleteDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <CustomerVoucherDelete
        visible={visibleDeleteDialog}
        onHide={() => setVisibleDeleteDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedDelete}
      />

      <CustomerVoucherEdit
        visible={visibleEditorDialog}
        onHide={() => setVisibleEditorDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEdit}
      />

      <CustomerVoucherList
        ref={listRef}
        onClickRowEdit={handleOnClickRowEdit}
        onClickRowDelete={handleOnClickRowDelete}
        onClickAddNew={handleOnClickAddNew}
      />
    </div>
  );
};

export default CustomerVoucherMain;
